export default __webpack_public_path__ + "static/timeline-view-b54eafe15df8780a3dd1202063b9e21c.png";